import React, { useContext, useState, useEffect } from 'react';
import './SearchInput.style.css';

import { FilterContext } from '../../contexts/FilterContext';
import Button from '../Button/Button.component';
import CorpusLabel from './SearchInput.utils';

interface SearchInputProps {
	showChips?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({ showChips }) => {
	const [queryArray, setQueryArray] = useState<string[]>([]);
	const [isDeleteButtonShown, setIsDeleteButtonShown] = useState(false);

	const [filters, setFilters] = useContext(FilterContext);
	const { searchTerms, corpus, lang, graphViewmode } = filters;

	useEffect(() => {
		setQueryArray(searchTerms);
	}, [searchTerms]);

	const handleQueryArrayChange = (event: any) => {
		const temporaryQueryArray = queryArray;
		temporaryQueryArray.splice(
			queryArray.indexOf(event.target.textContent),
			1,
		);
		setQueryArray([...temporaryQueryArray]);
		setFilters({ ...filters, searchTerms: queryArray });
	};

	return (
		<div className="search-input">
			<div className="search-input-wrapper">
				<input
					type="text"
					placeholder="Fyll inn søkeord, adskilt med komma  "
					onChange={(event: any) => {
						setQueryArray([...event.target.value.split(',')]);
					}}
					onFocus={() => {
						setIsDeleteButtonShown(true);
					}}
					onBlur={() => setIsDeleteButtonShown(false)}
					value={queryArray}
					onKeyUp={(event: any) => {
						if (
							event.key === 'Enter' &&
							event.target.value.length !== 0
						) {
							setFilters({
								...filters,
								searchTerms: [...event.target.value.split(',')],
							});
						}
					}}
				/>
				{isDeleteButtonShown ? (
					<button
						aria-label="Tøm søkefeltet"
						onClick={() => {
							setQueryArray([]);
							setIsDeleteButtonShown(false);
						}}
					>
						<i className="delete-button"></i>
					</button>
				) : (
					<button
						aria-label="Tøm søkefeltet"
						onClick={() => {
							setQueryArray([]);
							setIsDeleteButtonShown(false);
						}}
					>
						<i></i>
					</button>
				)}
			</div>
			{showChips && (
				<div className="button-wrapper">
					<CorpusLabel
						lang={lang}
						corpus={corpus}
						graphViewmode={graphViewmode}
					/>

					{searchTerms.length > 0 &&
						searchTerms.map(
							(query: string, index: number) =>
								query.length > 0 && (
									<Button
										chip
										buttonLabel={query}
										key={index}
										onClick={handleQueryArrayChange}
									/>
								),
						)}
				</div>
			)}
		</div>
	);
};

export default SearchInput;
